import { Pipe, PipeTransform } from '@angular/core';
import { forEach, isArray, isEmpty, isEqual, isObject } from 'lodash';

@Pipe({
  name: 'deepDiffObject',
  standalone: false,
})
export class DeepDiffObjectPipe implements PipeTransform {
  transform<T extends object>(obj1: T, obj2: T): Partial<T> {
    return diffObject(obj1, obj2);
  }
}

export function diffObject<T extends object>(obj1: T, obj2: T): Partial<T> {
  const changedProps: any = {};
  if (obj1 !== null && obj1 !== undefined && obj2 !== null) {
    forEach(obj2, (value, key) => {
      if (isObject(value)) {
        if (isArray(value)) {
          if (!isEqual(value, (obj1 as any)[key])) {
            changedProps[key] = value;
          }
        } else {
          const nestedChanges = diffObject((obj1 as any)[key], value);
          if (!isEmpty(nestedChanges)) {
            changedProps[key] = nestedChanges;
          }
        }
      } else if (!isEqual(value, (obj1 as any)[key])) {
        changedProps[key] = value;
      }
    });
  }

  return changedProps;
}
